import { Typography } from '@/src/shared/components/Typography';

import styles from './OurMission.module.scss';
import { Section } from '@/src/containers/Landings/Section';

export const OurMission = () => {
  return (
    <Section className={styles.container}>
      <Typography variant="heading" size="h5">
        Our Mission
      </Typography>
      <Typography variant="text" size="xl" fontWeight="regular">
        To empower advisors with video content that feels like you made it. Your
        voice, brand, and face come together to help you connect
        authentically—and drive real results.
      </Typography>
    </Section>
  );
};
